import {
  DateInfo,
  ScheduleEvent,
  TReservation,
} from "@timeedit/registration-schemas";
import { isValidId } from "@timeedit/registration-shared";
import dayjs from "dayjs";
import { ReactNode } from "react";
import { Event } from "react-big-calendar";

interface ExtraEventData {
  data: {
    days: Set<number>;
    name: string;
    groupId: number;
    actualStart: DateInfo;
    actualEnd: DateInfo;
    hasConflict: boolean;
    groupNumber?: number;
    reservations: TReservation[];
  };
  id: string;
  noSchedule?: boolean;
  body?: ReactNode;
  footer?: {
    wantToShowConflict: boolean;
    wantToShowSuccess: boolean;
    wantToShowWaitlist?: boolean;
    text?: string;
  };
}

export type CalendarEvent = Event &
  Required<Pick<Event, "end" | "start" | "title">> &
  ExtraEventData;

interface CreateEventProps {
  reservations: ScheduleEvent[];
}

/**
 * Be aware that start and end time objects are Date objects created from
 * times converted to a timezone based on user settings. They cannot be used
 * to go back to UTC! For anything other than displaying times in the
 * configured timezone, use the information on data.actualStart and
 * data.actualEnd
 */
export function createEvents({
  reservations,
}: CreateEventProps): CalendarEvent[] {
  const events: CalendarEvent[] =
    reservations.map((reservation) => {
      const event: CalendarEvent = {
        title: "",
        end: dayjs(reservation.end.local).toDate(),
        start: dayjs(reservation.start.local).toDate(),
        data: {
          name: reservation.name,
          groupId: reservation.groupId,
          actualStart: reservation.start,
          actualEnd: reservation.end,
          hasConflict: reservation.allocationConflicts.length > 0,
          reservations: [reservation.reservation],
          days: new Set(),
        },
        id: `${reservation.id}_${reservation.groupId}`, // This need to be unique
        noSchedule: !isValidId(reservation.id),
      };
      return event;
    }) ?? [];

  return events;
}
